import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterToolbar = ({ filters, onFilterChange, onClearFilters, resultsCount }) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'plant-1', label: 'Plant 1 - Main Facility' },
    { value: 'plant-2', label: 'Plant 2 - North Wing' },
    { value: 'plant-3', label: 'Plant 3 - South Wing' },
    { value: 'warehouse-1', label: 'Warehouse 1' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'expired', label: 'Expired' },
    { value: 'extended', label: 'Extended' },
    { value: 'closed', label: 'Closed' }
  ];

  const permitTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'hot-work', label: 'Hot Work' },
    { value: 'confined-space', label: 'Confined Space' },
    { value: 'electrical', label: 'Electrical Work' },
    { value: 'height-work', label: 'Work at Height' },
    { value: 'excavation', label: 'Excavation' },
    { value: 'general', label: 'General Work' }
  ];

  const hasActiveFilters = 
    filters?.location !== 'all' || 
    filters?.status !== 'all' || 
    filters?.permitType !== 'all' ||
    filters?.startDate ||
    filters?.endDate;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Filters</h2>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Location"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Permit Type"
          options={permitTypeOptions}
          value={filters?.permitType}
          onChange={(value) => onFilterChange('permitType', value)}
        />

        <Input
          label="Search"
          type="search"
          placeholder="Permit ID or description..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Start Date From"
          type="date"
          value={filters?.startDate}
          onChange={(e) => onFilterChange('startDate', e?.target?.value)}
        />

        <Input
          label="End Date To"
          type="date"
          value={filters?.endDate}
          onChange={(e) => onFilterChange('endDate', e?.target?.value)}
        />
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{resultsCount}</span> permit{resultsCount !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default FilterToolbar;